import React from "react";
import PropTypes from "prop-types";
import { PureModal } from "components/ui";
import EligibilityDetail from "./eligibility-detail";

const RowEligibilityButton = ({ patientGuid }) => (
  <PureModal
    renderTrigger={({ openModal }) => (
      <button
        type="button"
        className="row-eligibility-button"
        onClick={openModal}
        title="Check eligibility"
        aria-label="Check eligibility"
      >
        ?
      </button>
    )}
    renderContent={() => (
      <div className="row-eligibility-modal">
        <EligibilityDetail patientGuid={patientGuid} />
      </div>
    )}
    windowProps={{ title: "Eligibility check" }}
  />
);

RowEligibilityButton.propTypes = {
  patientGuid: PropTypes.string.isRequired
};

export default RowEligibilityButton;
